import { all } from "redux-saga/effects";
import * as authWatch from "./auth/watch";
import * as changDevice from "./changDevice/watch";

export default function* rootSaga() {
  yield all([
    authWatch.watchAuthCurrent(),
    authWatch.watchLoginGoogle(),
    authWatch.watchLogoutGoogle(),
    changDevice.watchChangeDeviceEdit(),
    changDevice.watchChangeDeviceEdit(),
  ]);
}
